import { defineFcm } from '../shared/factory';

export const FCM_DECISION_MAKERS_LEGISLATIVE_BODIES = defineFcm('decision_makers_legislative_bodies')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ globalValue, countryValue, localeValue }) => {
		if (countryValue || localeValue) return localeValue && countryValue;
		return globalValue;
	})
	.toConfig();
